import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["for", "id"]
const _hoisted_2 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", {
      for: _ctx.idCampo,
      id: `${_ctx.idCampo}-label`,
      class: "form-label"
    }, _toDisplayString(_ctx.label), 9, _hoisted_1),
    _createVNode(_component_MultiSelect, {
      "model-value": _ctx.selectedObjeto,
      options: _ctx.opcoesDisponiveis,
      "onUpdate:modelValue": _ctx.selecionarFornecedor,
      mode: "single",
      searchable: true,
      "close-on-select": true,
      valueProp: "valor",
      trackBy: "texto",
      label: "texto",
      placeHolder: "Selecione um Fornecedor",
      id: _ctx.idCampo,
      disabled: _ctx.disabled || _ctx.loading,
      aria: _ctx.ariaDoCampo
    }, null, 8, ["model-value", "options", "onUpdate:modelValue", "id", "disabled", "aria"]),
    (_ctx.mensagemErro)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: `${_ctx.idCampo}-erro`,
          class: "invalid-feedback d-block"
        }, _toDisplayString(_ctx.mensagemErro), 9, _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}